import { memo } from 'react';
import { isEmpty } from 'lodash';
import { useFirestore } from '@client/hooks/utils.hooks';
import { getReviewById } from '@client/selectors/entities/reviews';
import { upsertReview } from '@client/slices/entities/reviews.reducer';
import { Review } from '.';

interface FeaturedReviewProps {
  readonly reviewId: string;
  readonly disableProfileClick?: boolean;
  readonly className?: string;
}

export const FeaturedReview = memo<FeaturedReviewProps>(({ reviewId, ...restProps }) => {
  const [review, isLoading] = useFirestore(
    (SDK) => SDK.Reviews.get(reviewId),
    {
      key: reviewId,
      upserter: upsertReview,
      selector: getReviewById,
    },
  );

  if (isEmpty(review) || isLoading) {
    return null;
  }

  return (
    <Review
      {...restProps}
      {...review}
      isFeatured
    />
  );
});
